module.exports = __webpack_public_path__ + "img/teachers-header-bg.f150ebe2.svg";